import { useTranslation } from 'react-i18next';
import { ContractTemplate } from '../../../hooks/useContractTemplate';
import Card from '../../../components/Card/Card';
import SmallCheckBox from '../../../components/SmallCheckBox/SmallCheckBox';
import Subtitle from '../../../components/Subtitle/Subtitle';
import TinyText from '../../../components/TinyText/TinyText';

type Props = {
  contractTemplate: ContractTemplate;
  updateContractTemplate: (value: any) => void;
};

export default function AdditionalRequirementsSection({ contractTemplate, updateContractTemplate }: Props) {
  const { t } = useTranslation();

  return (
    <Card>
      <>
        <Subtitle text={t('contract_template.additional_requirements.title')} />
        <TinyText text={t('contract_template.additional_requirements.requires_follow_up.hint')} />
        <SmallCheckBox
          defaultValue={contractTemplate?.additionalRequirements?.requiresFollowUpMeeting}
          label={t('contract_template.additional_requirements.requires_follow_up')!}
          onChange={(c) =>
            updateContractTemplate({
              additionalRequirements: { ...contractTemplate.additionalRequirements, requiresFollowUpMeeting: c.target.checked },
            })
          }
        />
        <TinyText text={t('contract_template.additional_requirements.requires_employee_signature.hint')} />
        <SmallCheckBox
          defaultValue={contractTemplate?.additionalRequirements?.requiresEmployeeSignature}
          label={t('contract_template.additional_requirements.requires_employee_signature')!}
          onChange={(c) =>
            updateContractTemplate({
              additionalRequirements: { ...contractTemplate.additionalRequirements, requiresEmployeeSignature: c.target.checked },
            })
          }
        />
      </>
    </Card>
  );
}

